import React from 'react'

import { useElementStyle } from './styles'
import BlockPlugin from './BlockPlugin'

const getSize = name => {
  switch (name) {
    case 'h1':
      return '3em'
    case 'h2':
      return '2.2em'
    case 'h3':
      return '1.6em'
    case 'small':
      return '.8em'
    default:
      return '2em'
  }
}

const Element = ({ name, children, attributes, ...props }) => {
  const style = {
    ...useElementStyle(props.element),
    fontSize: getSize(name),
    fontWeight: 500
  }

  return (
    <div style={style} {...attributes}>
      {children}
    </div>
  )
}

const getIcon = name => {
  switch (name) {
    case 'h1':
      return 'RiH1'
    case 'h2':
      return 'RiH2'
    case 'h3':
      return 'RiH3'
    case 'small':
      return 'RiFontSize'
    default:
      return 'RiH1'
  }
}

const ToggleIcon = props => <BlockPlugin.ToggleIcon icon={getIcon(props.name)} name="h1" {...props} />

const FontSizePlugin = {
  ...BlockPlugin,
  ToggleIcon,
  Element
}

export default FontSizePlugin
